import axios from 'axios';
import { API_BASE_URL } from '../config';

const API_URL = `${API_BASE_URL}/user`;

/**
 * Ottiene il token di autenticazione dal localStorage
 */
const getAuthToken = () => {
  return localStorage.getItem('token');
};

/**
 * Ottiene il profilo dell'utente corrente
 */
export const getProfile = async () => {
  try {
    const response = await axios.get(`${API_URL}/profile`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nel recupero del profilo' };
  }
};

/**
 * Aggiorna il nome dell'utente
 */
export const updateName = async (firstName, lastName) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile/name`,
      { firstName, lastName },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nell\'aggiornamento del nome' };
  }
};

/**
 * Aggiorna l'email dell'utente
 */
export const updateEmail = async (email, password) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile/email`,
      { email, password },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nell\'aggiornamento dell\'email' };
  }
};

/**
 * Aggiorna la password dell'utente
 */
export const updatePassword = async (currentPassword, newPassword, confirmPassword) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile/password`,
      { currentPassword, newPassword, confirmPassword },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nell\'aggiornamento della password' };
  }
};

/**
 * Ottiene i log delle attività dell'utente
 */
export const getActivityLogs = async (limit = 50, offset = 0, actionType = null) => {
  try {
    const params = new URLSearchParams({ limit, offset });
    if (actionType) params.append('actionType', actionType);

    const response = await axios.get(`${API_URL}/activity-logs?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nel recupero dei log' };
  }
};

/**
 * Ottiene le statistiche di sicurezza dell'utente
 */
export const getSecurityStats = async (days = 30) => {
  try {
    const response = await axios.get(`${API_URL}/security-stats?days=${days}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nel recupero delle statistiche' };
  }
};

/**
 * Aggiorna il profilo completo
 */
export const updateProfile = async (firstName, lastName) => {
  try {
    const response = await axios.put(
      `${API_URL}/profile`,
      { firstName, lastName },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Errore nell\'aggiornamento del profilo' };
  }
};
